// extracted by mini-css-extract-plugin
export default {"card":"index_card__1hB1Z"};